// Translations for names stored in the database (faculties, courses).
// Armenian source strings are stored as Unicode escapes.
import type { Locale } from "./LanguageContext";

const DB_NAME_TRANSLATIONS: Record<string, { ru: string; en: string }> = {
  "\u054E\u0565\u0562 \u053E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0574\u0561\u0576 \u0556\u0561\u056F\u0578\u0582\u056C\u057F\u0565\u057F": { ru: "Факультет веб-программирования", en: "Web Development Faculty" },
  "\u053E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0574\u0561\u0576 \u0556\u0561\u056F\u0578\u0582\u056C\u057F\u0565\u057F": { ru: "Факультет программирования", en: "Programming Faculty" },
  "\u0544\u0578\u0582\u056C\u057F\u056B\u0574\u0565\u0564\u056B\u0561\u0575\u056B \u0556\u0561\u056F\u0578\u0582\u056C\u057F\u0565\u057F": { ru: "Факультет мультимедиа", en: "Multimedia Faculty" },
  "\u053E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0574\u0561\u0576 \u0570\u056B\u0574\u0578\u0582\u0576\u0584\u0576\u0565\u0580": { ru: "Основы программирования", en: "Programming Fundamentals" },
  "C++ \u053E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0578\u0582\u0574": { ru: "Программирование на C++", en: "C++ Programming" },
  "C# \u053E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0578\u0582\u0574": { ru: "Программирование на C#", en: "C# Programming" },
  "Python \u053E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0578\u0582\u0574": { ru: "Программирование на Python", en: "Python Programming" },
  "Java \u053E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0578\u0582\u0574": { ru: "Программирование на Java", en: "Java Programming" },
  "\u053D\u0561\u0572\u0565\u0580\u056B \u056E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0578\u0582\u0574": { ru: "Разработка игр", en: "Game Development" },
  "\u0531\u0580\u0570\u0565\u057D\u057F\u0561\u056F\u0561\u0576 \u0562\u0561\u0576\u0561\u056F\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576": { ru: "Искусственный интеллект", en: "Artificial Intelligence" },
  "\u053F\u056B\u0562\u0565\u057C\u0561\u0576\u057E\u057F\u0561\u0576\u0563\u0578\u0582\u0569\u0575\u0578\u0582\u0576": { ru: "Кибербезопасность", en: "Cybersecurity" },
  "\u0533\u0580\u0561\u0586\u056B\u056F\u0561\u056F\u0561\u0576 \u0564\u056B\u0566\u0561\u0575\u0576": { ru: "Графический дизайн", en: "Graphic Design" },
  "UX/UI \u0564\u056B\u0566\u0561\u0575\u0576": { ru: "UX/UI дизайн", en: "UX/UI Design" },
};

export const translateDbName = (name: string | null | undefined, locale: Locale): string => {
  if (!name) return "";
  if (locale === "hy") return name;
  const entry = DB_NAME_TRANSLATIONS[name.trim()];
  return entry ? entry[locale] : name;
};


/**
 * Picks a localized DB column (e.g. title_ru / title_en) with Armenian fallback.
 */
export const pickLocalized = (
  row: unknown,
  field: string,
  locale: Locale,
): string => {
  if (!row || typeof row !== "object") return "";
  const record = row as Record<string, unknown>;
  const base = (record[field] as string | null | undefined) ?? "";
  if (locale === "hy") return base;
  const localized = record[`${field}_${locale}`] as string | null | undefined;
  return localized && localized.trim() !== "" ? localized : translateDbName(base, locale);
};
